module.exports = __webpack_public_path__ + "static/r4-256d961fa5c9a2033dda2782e5f20845.svg";